import React, { useState } from 'react';
import { X } from 'lucide-react';
import Button from '../../ui/Button';
import ConditionBuilder from '../../common/ConditionBuilder';
import { CONDITION_OPTIONS } from '../../../constants/segmentConstants';
import { Condition } from '../../../types/segments/segments.types';

interface TrueFalsePanelProps {
  onClose: () => void;
  onSave: (data: any) => void;
  conditions?: { [key: string]: Condition[] };
}

const TrueFalsePanel: React.FC<TrueFalsePanelProps> = ({
  onClose,
  onSave,
  conditions = {},
}) => {
  const [localConditions, setLocalConditions] = useState<{
    [key: string]: Condition[];
  }>(conditions);

  const handleSave = () => {
    onSave({
      conditions: localConditions,
      type: 'true-false',
    });
  };

  return (
    <div className="bg-card rounded-lg shadow-md border border-border w-[32vw] h-full overflow-y-auto">
      {/* Header */}
      <div className="flex items-center justify-between p-4 border-b border-border">
        <h3 className="text-lg font-semibold text-foreground">
          True/False Branch
        </h3>
        <button
          onClick={onClose}
          className="text-muted-foreground hover:text-foreground transition-colors"
        >
          <X className="w-4 h-4" />
        </button>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-y-auto px-3 py-3">
        <ConditionBuilder
          conditions={localConditions}
          onConditionsChange={setLocalConditions}
          dataSourceOptions={CONDITION_OPTIONS}
        />
      </div>

      {/* Footer */}
      <div className="p-4 border-t border-border">
        <Button
          variant="primary"
          onClick={handleSave}
          className="w-full bg-primary hover:bg-primary-hover mb-3"
        >
          Save Branch
        </Button>
        <div className="flex items-center space-x-3">
          <Button variant="outline" onClick={onClose} className="flex-1">
            Cancel
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TrueFalsePanel;
